import { MunicipalitiesService } from '@api/services/municipalities.service';
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '@ui/modal/modal.component';
import { AppService } from '../app.service';
import { Municipality } from '@api/models/municipality.model';
import { MODAL_REF, ModalService } from '@ui/modal/modal.service';

@Component({
  selector: 'app-municipality-selector-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  template: `
    <ui-modal
      [title]="'Selecteer Gemeente'"
      [hideSubmit]="true"
      [hideCancel]="true"
      [closeOnBackdrop]="closeOnBackdrop"
      (close)="onClose()"
    >
      <div class="space-y-6">
        <div class="text-center">
          <h2 class="text-gray-900 text-lg font-semibold mb-2">
            Selecteer de gemeente waar je wilt werken
          </h2>
          <p class="text-gray-500 text-sm">
            Kies een gemeente om te beginnen met werken
          </p>
        </div>

        <div class="max-h-[60vh] overflow-y-auto rounded-lg">
          <ul class="divide-y divide-gray-100">
            @for (municipality of municipalities; track municipality.id) {
              <li>
                <button
                  (click)="selectMunicipality(municipality)"
                  class="w-full px-4 py-3 flex items-center gap-x-3 text-left transition-colors"
                  [class.bg-blue-50]="selectedMunicipalityId === municipality.id"
                  [class.hover:bg-gray-50]="selectedMunicipalityId !== municipality.id"
                >
                  <div class="min-w-0 flex-auto">
                    <p class="text-sm font-medium"
                       [class.text-blue-600]="selectedMunicipalityId === municipality.id"
                       [class.text-gray-900]="selectedMunicipalityId !== municipality.id">
                      {{ municipality.name }}
                    </p>
                  </div>
                  @if (selectedMunicipalityId === municipality.id) {
                    <svg class="h-5 w-5 text-blue-600 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                  }
                </button>
              </li>
            }
          </ul>
        </div>
      </div>
    </ui-modal>
  `
})
export class MunicipalitySelectorModalComponent {
  closeOnBackdrop = false;

  private appService = inject(AppService);
  private municipalitiesService = inject(MunicipalitiesService);
  private modalRef = inject(MODAL_REF);
  private modalService = inject(ModalService);

  municipalities: Municipality[] = [];
  selectedMunicipalityId: string | null = null;

  constructor() {
    // Get municipalities from the user data
    this.municipalitiesService.getMunicipalities().subscribe((municipalities) => {
      this.municipalities = municipalities.data;
    });
    this.selectedMunicipalityId = this.appService.municipalityId();
  }

  selectMunicipality(municipality: Municipality) {
    this.selectedMunicipalityId = municipality.id;
    this.appService.setCurrentMunicipalityId(municipality.id);
    this.onClose();
  }

  onClose() {
    this.modalService.close(this.modalRef);
  }
}
